const RADIUS_SELECTED = 6.9;
const RADIUS_UNSELECTED = 3;

export function CustomDot(props: any) {
  const { cy, cx, color, onDotClick, selectedValue, isActive, payload } = props;

  const isSelected =
    (selectedValue?.cx === cx && selectedValue?.cy === cy) || isActive;

  return (
    <g
      data-chart-x={cx}
      data-chart-y={cy}
      style={{ cursor: "pointer" }}
      onClick={
        onDotClick ? () => onDotClick({ ...payload, cx, cy }) : undefined
      }
      data-radius={isSelected ? RADIUS_UNSELECTED : RADIUS_SELECTED}
    >
      {!isSelected ? (
        <circle
          cx={cx}
          cy={cy}
          onClick={
            onDotClick ? () => onDotClick({ ...payload, cx, cy }) : undefined
          }
          r={RADIUS_UNSELECTED}
          fill={color}
          style={{ cursor: "pointer" }}
        />
      ) : (
        <>
          <circle
            onClick={
              onDotClick ? () => onDotClick({ ...payload, cx, cy }) : undefined
            }
            cx={cx}
            cy={cy}
            r={RADIUS_SELECTED / 2}
            fill={color}
          />
          <circle
            cx={cx}
            cy={cy}
            onClick={
              onDotClick ? () => onDotClick({ ...payload, cx, cy }) : undefined
            }
            r={RADIUS_SELECTED}
            fill="none"
            stroke={color}
            strokeWidth={2}
            strokeOpacity={0.6}
            style={{ cursor: "pointer" }}
          />
        </>
      )}
    </g>
  );
}
